import { SpinStatusResponse } from "../../types/rewards";

export const getSpinStatusModel = (
  response: SpinStatusResponse
): SpinStatusResponse => response;
